var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DDS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87,36c0,11-22,42-22,42S43,47,43,36a22,22,0,0,1,44,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 65,
    cy: 36,
    r: 12
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "46 57 29 57 12 101 14 105 116 105 118 101 101 57 84 57"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDds);
export default __webpack_public_path__ + "static/media/dds.85e8af0573a42a267832f71e6e4a0b7b.svg";
export { ForwardRef as ReactComponent };